// extracted by mini-css-extract-plugin
module.exports = {"toast":"toast_toast__3pl4-","placeHolderShimmer":"toast_placeHolderShimmer__1i817"};